export enum RequestType {
    GET_ACCOUNTS = 'GET_ACCOUNTS',
    GET_PARTNERS = 'GET_PARTNERS',
    GET_ACCOUNT_INFORMATION = 'GET_ACCOUNT_INFORMATION',
    INITIALIZE_SHOPPING_CART = 'INITIALIZE_SHOPPING_CART',
    GET_BROADBAND_OFFER = 'GET_BROADBAND_OFFER',
    SUBMIT_SHOPPING_CART = 'SUBMIT_SHOPPING_CART',
    GET_PURCHASE_ELIGIBILITY = 'GET_PURCHASE_ELIGIBILITY',
    GET_SHOP_STATUS = 'GET_SHOP_STATUS',
}

export enum RequestStatus {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
}

export interface OrderRequest {
    requestId: string;
    requestType: RequestType;
    status: RequestStatus;
}
